import { TypedDocumentNode, gql } from '@apollo/client';
import { faCrown } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { withFragments } from '@sorare/core/src/lib/gql';

import { getAllowLegendRule_so5Rules } from './__generated__/getAllowLegend.graphql';

// We only want to display an error if any. This rule is implicit
// and shouldn't be display all the time hence the undefined defaultMessage
export const getAllowLegendRule = withFragments(
  (rules: getAllowLegendRule_so5Rules, error: string) => {
    const rule = rules.allowLegend;
    if (rule || !error) {
      return null;
    }

    return {
      id: 'allowLegend',
      label: (
        <FormattedMessage
          id="Rules.allowLegend"
          defaultMessage="Legends are not allowed"
        />
      ),
      icon: (
        <FontAwesomeIcon
          icon={faCrown}
          color="var(--c-rivals-loss)"
          width="16"
          height="16"
        />
      ),
      error,
    };
  },
  {
    so5Rules: gql`
      fragment getAllowLegendRule_so5Rules on So5Rules {
        id
        allowLegend
      }
    ` as TypedDocumentNode<getAllowLegendRule_so5Rules>,
  }
);
